// extracted by mini-css-extract-plugin
export default {"external":"asHpQk","amountValue":"bsHpQk","valueWidth":"csHpQk","disclaimer":"dsHpQk","incDecInput":"esHpQk"};